import { render, staticRenderFns } from "./EYMPower.vue?vue&type=template&id=22a156fd&scoped=true&"
import script from "./EYMPower.vue?vue&type=script&lang=js&"
export * from "./EYMPower.vue?vue&type=script&lang=js&"
import style0 from "./EYMPower.vue?vue&type=style&index=0&id=22a156fd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a156fd",
  null
  
)

export default component.exports